export default __webpack_public_path__ + "static/media/roof1.62ed74aa.jpeg";